
<div class="socket-user-item" [class.chat-open]="chatOpen" [class.socket-user-hover]="hover" (mouseover)="hover = true" (mouseleave)="hover = false" >

  @if (chatOpen) {
    <div class="chat">
      <div class="chat-header">
        <div class="hover-bttn" title="Minimieren" (click)="chatOpen = false; hover = false;">
          <ion-icon name="fa-minus"></ion-icon>
        </div>
      </div>
      @if (user.chat.length == 0) {
        <div class="message-description">
          <span>Frage {{user.fullName}} etwas über dieses Ticket.</span><br>
          <p>Die Nachricht wird {{user.fullName}} direkt zugestellt und kann sofort antworten.
          Beim Wechsel des Tickets wird die Unterhaltung beendet.</p>
        </div>
      }
      @for (message of user.chat; track message) {
        <div class="chat-message" [class.message-self]="message.fromSelf">
          <div class="message-wrapper">
            <div class="message-bubble">
              <div class="chat-message-header">
                <div class="chat-message-name">{{message.fullname}}</div>
              </div>
              <div class="message-content">
                {{message.message}}
              </div>
            </div>
            <div class="message-time">
              {{message.timestamp | date: 'HH:mm'}}
            </div>
          </div>
        </div>
      }
      <div class="chat-input">
        <textarea #msgtextarea placeholder="Nachricht..." (keyup)="auto_grow(msgtextarea)" [(ngModel)]="chatInput" (keydown.alt.enter)="chatInput = chatInput + '\n'" (keydown.enter)="sendChatMessage()"></textarea>
        <div class="hover-bttn" (click)="sendChatMessage()">
          <ion-icon name="fa-paperplane"></ion-icon>
        </div>
      </div>
    </div>
  }

  @if (!hover && !chatOpen) {
    <div>{{user.initials}}</div>
  }
  @if (hover && !chatOpen) {
    <div class="socket-user-hover-content">
      <div>{{user.fullName}}</div>
      <div class="hover-bttn" title="Nachricht schreiben" (click)="startChat()">
        <ion-icon name="fa-messages-duotone"></ion-icon>
      </div>
    </div>
  }


</div>
